export const CONTENT_TYPES = Object.freeze({
    TITLE: "TITLE",
    ALT: "ALT",
    TAB: "TAB",
    HASH: "HASH",
});

export const DEFAULT_ORGANIZATION_LOGO_URL = "/static/img/minilogo4.png";
